import { Button, Flex, Select } from 'antd'
import axios, { AxiosRequestConfig } from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../taskpane/@common/contexts/auth'
import { RightOutlined, CheckOutlined } from '@ant-design/icons';
import { CommunicationFeatureType, linkingModule } from '../../../taskpane/@common/types/enums';
import { retrieveDisplayNameForUser } from '../../../taskpane/@common/utils/helper';
import { NamingFrameworkContext } from '../../../taskpane/@common/contexts/naming-framework';
import { namingFrameWorkNames } from '../../../config/constants';

export enum EmailLabelType {
    DRAFT = 'DRAFT',
    INBOX = 'INBOX',
    SENT = 'SENT',
    UNREAD = 'UNREAD',
    TRASH = 'TRASH',
    STARRED = 'STARRED',
}

const Home = () => {
    const auth = useContext(AuthContext)
    const [loading, setLoading] = useState(false)
    const [messageSent, setMessageSent] = useState(false)
    const namingFramework = useContext(NamingFrameworkContext)
    const features = [
        { value: CommunicationFeatureType.LEAD_MANAGEMENT, label: <span>{namingFramework.namingFramework?.['lead'] ?? namingFrameWorkNames['lead']} Management</span> },
        { value: CommunicationFeatureType.PROPOSAL_MANAGEMENT, label: <span>Proposal Management</span> }
    ]
    const [proposalTypes, setProposalTypes] = useState([])
    const [proposalTypesLoading, setProposalTypesLoading] = useState({
        isProposalType: false,
        isProposals: false
    });
    const [leadsLoading, setLeadsLoading] = useState({
        groups: false,
        company: false,
        opportunities: false,
        pocs: false
    })

    const [selectedFeature, setSelectedFeature] = useState(CommunicationFeatureType.LEAD_MANAGEMENT)
    const [selectedProposalTypes, setSelectedProposalTypes] = useState([])
    const [selectedProposals, setSelectedProposals] = useState([])
    const [proposals, setProposals] = useState([])

    useEffect(() => {
        fetchGroups()
        fetchCompaniesAndOpportunities()
    }, [])

    const sendData = async () => {
        try {
            setLoading(true)
            const body = Office.context.mailbox.item.body
            const bcc = Office.context.mailbox.item.bcc
            const attachments = Office.context.mailbox.item.attachments
            let module = linkingModule.PROPOSAL_MANAGEMENT
            switch (selectedFeature) {
                case CommunicationFeatureType.PROPOSAL_MANAGEMENT:
                    module = linkingModule.PROPOSAL_MANAGEMENT
                    break;
                case CommunicationFeatureType.BID_MANAGEMENT_US:
                    module = linkingModule.BID_MANAGEMENT_US
                    break;
                case CommunicationFeatureType.LEAD_MANAGEMENT:
                    module = linkingModule.LEAD_MANAGEMENT
                    break;
                default:
                    module = linkingModule.LEAD_MANAGEMENT
            }
            const item = Office.context.mailbox.item;
            const labels = [];
            const currentUser = Office.context.mailbox.userProfile.emailAddress;

            if (item.to && Array.isArray(item.to)) {
                const recipients = item.to.map(each => each.emailAddress);

                if (recipients.includes(currentUser)) {
                    labels.push("INBOX")
                    labels.push('UNREAD')
                } else if (item.sender && item.sender.emailAddress === currentUser) {
                    labels.push("SENT")
                }
            }

            let payload: any = {
                subject: Office.context.mailbox.item.subject,
                sender: Office.context.mailbox.item.sender.emailAddress,
                receivers: Office.context.mailbox.item.to.map(each => each.emailAddress),
                cc: Office.context.mailbox.item.cc.map(each => each.emailAddress),
                emailMessageId: Office.context.mailbox.item.itemId,
                emailThreadId: Office.context.mailbox.item.conversationId,
                labels: labels,
                module: module,
                customer: selectedCompanies,
                type: selectedFeature,
                opportunity: selectedOppportunities,
                poc: selectedPOCs,
                proposalTypes: selectedProposalTypes,
                proposals: selectedProposals,
                ...(Office.context.mailbox.item.dateTimeCreated ? { createdAt: Office.context.mailbox.item.dateTimeCreated } : {})
            }


            await new Promise((res) => {
                body.getAsync(Office.CoercionType.Html, function (asyncResult) {
                    if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                        payload.message = asyncResult.value
                        res(true)
                    }
                })
            })

            if (attachments?.length) {
                const _attachmentsPayload = [];
                const cidMapping = {}; // This will map cid to attachment
                const bodyContent = Office.context.mailbox.item.body; // Get email body

                // Extract HTML body content as a string
                await new Promise((res) => {
                    bodyContent.getAsync(Office.CoercionType.Html, (asyncResult) => {
                        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                            const htmlBody = asyncResult.value;

                            // Use regex to find cid references in the src attribute
                            const cidRegex = /cid:([^'">]+)/g;
                            let match;
                            while ((match = cidRegex.exec(htmlBody)) !== null) {
                                // Store each cid and its corresponding image reference
                                cidMapping[match[1]] = null;
                            }

                            res(true);
                        }
                    });
                });

                // Loop through each attachment
                for (const attachment of attachments) {
                    await new Promise((res) => {
                        Office.context.mailbox.item.getAttachmentContentAsync(attachment.id, {}, (asyncResult) => {
                            if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                                const attachmentWithContent: {
                                    value: string;
                                    attachmentType: string;
                                    contentType: string;
                                    id: string;
                                    isInline: boolean;
                                    name: string;
                                    size: number;
                                    cid?: string
                                } = {
                                    ...attachment,
                                    value: asyncResult.value.content,
                                };

                                // Check if the attachment is inline
                                if (attachment.isInline) {
                                    for (const cid in cidMapping) {
                                        if (cidMapping[cid] === null) {
                                            cidMapping[cid] = attachmentWithContent;
                                            attachmentWithContent.cid = cid;
                                            break;
                                        }
                                    }
                                }

                                _attachmentsPayload.push(attachmentWithContent);
                                res(true);
                            }
                        });
                    });
                }

                payload._attachments = _attachmentsPayload;
            }



            // bcc.getAsync({}, (asyncResult) => {
            //     if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
            //         data.bcc = asyncResult.value
            //     }
            // })
            await axios.post(`https://code.arena.${auth.workspaceUrl}.inncircles.com/mail-communication/outlook-add-in`, payload)
            setLoading(false)
            setMessageSent(true)
            // Disappear the message after 5 seconds
            setTimeout(() => {
                setMessageSent(false)
            }, 5000)
        } catch (err) {
            setLoading(false)
        }
    }


    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token && auth.user) {
            fetchGroups()
            fetchCompaniesAndOpportunities()
        }
    }, [auth.user])

    const [groups, setGroups] = useState([])
    const fetchGroups = async () => {
        try {
            setLeadsLoading(prev => ({ ...prev, groups: true }))
            const res = await axios.get(`https://code.arena.${auth.workspaceUrl}.inncircles.com/company-group/list`)
            if (res.data.success) {
                setGroups(res.data.data?.map(each => ({ value: each._id, label: each.name })))
            }
        } catch (error) {

        } finally {
            setLeadsLoading(prev => ({ ...prev, groups: false }))
        }
    }

    const [company, setCompany] = useState()
    const onGroupChange = async (value: string[]) => {
        // Groups selection is now handled independently
        // Companies are fetched when lead management module is selected
    }

    const [selectedCompanies, setSelectedCompanies] = useState([])
    const onCustomerSelected = (value: string[]) => {
        setSelectedCompanies(value)
        getPOCWRTCompanies(value)
    }

    const [pocs, setPocs] = useState()
    const getPOCWRTCompanies = async (selectedCompanies?: string[]) => {
        try {
            setLeadsLoading(prev => ({ ...prev, pocs: true }))
            const res = await axios.post(`https://code.arena.${auth.workspaceUrl}.inncircles.com/company/list/pocs`, {
                companies: selectedCompanies
            })
            if (res.data.success) {
                setPocs(res.data.data?.map(each => ({ value: each._id, label: retrieveDisplayNameForUser(each) })))
                let pocs = []
                for (let i = 0; i < selectedPOCs.length; i++) {
                    res.data.data.forEach((each) => {
                        if (each._id == selectedPOCs[i]) {
                            pocs.push(selectedPOCs[i])
                        }
                    })
                }
                setSelectedPOCs(pocs)
            }
        } catch (error) {

        } finally {
            setLeadsLoading(prev => ({ ...prev, pocs: false }))
        }
    }


    const [selectedPOCs, setSelectedPOCs] = useState([])
    const [opportunities, setOpportunities] = useState()
    const onPOCSelected = async (value: string[]) => {
        setSelectedPOCs(value)
        // Opportunities are now fetched when lead management module is selected
        // POC selection is handled independently
    }

    const [selectedOppportunities, setSelectedOppportunities] = useState([])
    const onOpportunitySelected = async (value: string[]) => {
        setSelectedOppportunities(value)
    }

    const fetchProposalTypes = async () => {
        try {
            setProposalTypesLoading(prev => ({ ...prev, isProposalType: true }));
            const res = await axios.get(`https://code.arena.${auth.workspaceUrl}.inncircles.com/proposal/proposal-types`)
            if (res.data.success) {
                setProposalTypes(res.data.data?.map(each => ({ value: each._id, label: each.name })))
            }
        } catch (error) {

        } finally {
            setProposalTypesLoading(prev => ({ ...prev, isProposalType: false }));
        }
    }


    const fetchCompaniesAndOpportunities = async () => {
        try {
            // Fetch companies (all companies without group filter)
            setLeadsLoading(prev => ({ ...prev, company: true }))
            const companyRequest: AxiosRequestConfig = {
                method: 'POST',
                url: `https://code.arena.${auth.workspaceUrl}.inncircles.com/company/list/all`,
                data: {
                    filters: { groups: [] }
                }
            }
            const companyRes = await axios(companyRequest)

            if (companyRes.data.success) {
                setCompany(companyRes.data.data?.map(each => ({ value: each._id, label: each.companyName })))
            }
            setLeadsLoading(prev => ({ ...prev, company: false }))

            // Fetch opportunities (all opportunities without POC filter)
            setLeadsLoading(prev => ({ ...prev, opportunities: true }))
            const opportunityRes = await axios.post(`https://code.arena.${auth.workspaceUrl}.inncircles.com/lead/leads`)

            if (opportunityRes.data.success) {
                setOpportunities(opportunityRes.data.data?.map(each => ({ value: each._id, label: `${each?.id} - ${each.name}` })))
            }
        } catch (error) {

        } finally {
            setLeadsLoading(prev => ({ ...prev, company: false }))
            setLeadsLoading(prev => ({ ...prev, opportunities: false }))
        }
    }

    const onFeatureSelected = (value: CommunicationFeatureType) => {
        setSelectedFeature(value)
        if (value == CommunicationFeatureType.PROPOSAL_MANAGEMENT) {
            setSelectedProposals([]);
            setSelectedProposalTypes([]);
            fetchProposalTypes()
        } else if (value == CommunicationFeatureType.LEAD_MANAGEMENT) {
            setSelectedCompanies([]);
            setSelectedPOCs([]);
            setSelectedOppportunities([]);
            // Fetch both companies and opportunities when lead management is selected
            fetchCompaniesAndOpportunities()
            fetchGroups()
        }
    }

    const onProposalTypesSelected = async (value: string[]) => {
        try {
            setSelectedProposalTypes(value)
            setProposalTypesLoading(prev => ({ ...prev, isProposals: true }))
            const res = await axios.post(`https://code.arena.${auth.workspaceUrl}.inncircles.com/proposal/proposal-based-on-types`, value)
            if (res.data.success) {
                setProposals(res.data.data?.map(each => ({ value: each._id, label: `${each.id} - ${each.name}` })))
                let proposals = []
                for (let i = 0; i < selectedProposals.length; i++) {
                    res.data.data.forEach((each) => {
                        if (each._id == selectedProposals[i]) {
                            proposals.push(selectedProposals[i])
                        }
                    })
                }
                setSelectedProposals(proposals)
            }
        } catch (error) {

        } finally {
            setProposalTypesLoading(prev => ({ ...prev, isProposals: false }))
        }
    }

    const onProposalsSelected = (value: string[]) => {
        setSelectedProposals(value)
    }


    return (
        <>
            <Flex align='center' justify='center' style={{ flexDirection: 'column', width: '100%', height: '90vh' }}>
                <h2 style={{ marginBottom: 12, fontWeight: 600 }}>Select an Action</h2>
                <Flex style={{ flexDirection: 'column', width: '80%', gap: '1rem', marginBottom: '1rem' }}>
                    <Select defaultValue={CommunicationFeatureType.LEAD_MANAGEMENT} value={selectedFeature}
                        options={features} onChange={onFeatureSelected} />
                    {
                        selectedFeature === CommunicationFeatureType.LEAD_MANAGEMENT &&
                        <>
                            <Select maxTagCount={'responsive'} options={groups} loading={leadsLoading.groups} optionFilterProp="label" mode="multiple" allowClear onChange={onGroupChange} placeholder="Groups" />
                            <Select maxTagCount={'responsive'} options={company} loading={leadsLoading.company} optionFilterProp="label" mode="multiple" allowClear value={selectedCompanies} onChange={onCustomerSelected} placeholder="Customer" />
                            <Select maxTagCount={'responsive'} options={pocs} loading={leadsLoading.pocs} optionFilterProp="label" mode="multiple" allowClear value={selectedPOCs} onChange={onPOCSelected} placeholder="Customer POC" />
                            <Select maxTagCount={'responsive'} options={opportunities} loading={leadsLoading.opportunities} optionFilterProp="label" mode="multiple" allowClear value={selectedOppportunities} onChange={onOpportunitySelected} placeholder="Opportunity" />
                        </>
                    }
                    {
                        selectedFeature === CommunicationFeatureType.PROPOSAL_MANAGEMENT &&
                        <>
                            <Select maxTagCount={'responsive'} loading={proposalTypesLoading.isProposalType} options={proposalTypes} optionFilterProp="label" mode="multiple" allowClear value={selectedProposalTypes} onChange={onProposalTypesSelected} placeholder="Proposal type" />
                            <Select maxTagCount={'responsive'} loading={proposalTypesLoading.isProposals} options={proposals} optionFilterProp="label" mode="multiple" allowClear value={selectedProposals} onChange={onProposalsSelected} placeholder="Proposals" />
                        </>
                    }
                </Flex>
                <Button style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 2 }}
                    loading={loading} type="primary" shape="round" onClick={sendData}>
                    Send Mail to Arena <RightOutlined size={18} />
                </Button>

                {/* <Button onClick={fetchCustomers}>Fetch Data</Button> */}

                {
                    messageSent &&
                    <span>Mail Sent Successfully <CheckOutlined color='green' /></span>
                }
            </Flex>
        </>
    )
}

export default Home
